export default __webpack_public_path__ + "static/media/MyHotsauce2.9c5ff82b.png";